const isWeb = () =>
  typeof window !== "undefined" && typeof window.document !== "undefined"

const isNode = () => {
  return (
    typeof process !== "undefined" &&
    process.versions != null &&
    process.versions.node != null
  )
}

export { isWeb, isNode }
